module.exports = __webpack_public_path__ + "img/agreement.c169199e.png";